import { Grid } from '@mui/material';
import PropTypes from 'prop-types';

const propTypes = {
  colDef: PropTypes.oneOfType([PropTypes.object]),
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
  message: PropTypes.string,
};
const defaultProps = {
  data: 0,
  colDef: 0,
  message: '',
};

const CustomTooltip = (props) => {
  const { colDef, data, message: toolTipMessage } = props;
  const rightPosition =
    toolTipMessage === 'The project hasn’t started yet! Add a start date to get started.'
      ? 190
      : 245;
  const ColId = colDef.field;
  const ColVal = data[ColId];

  return (
    <div>
      <Grid container spacing={2}>
        {data === 0 && ColId === 'sprint1' && toolTipMessage !== '' && (
          <Grid>
            {ColVal === undefined && (
              <Grid container className="tooltip" style={{ right: rightPosition }}>
                <div className="tooltip-bottom">
                  <strong>{toolTipMessage}</strong>
                </div>
              </Grid>
            )}
          </Grid>
        )}
      </Grid>
    </div>
  );
};

CustomTooltip.propTypes = propTypes;
CustomTooltip.defaultProps = defaultProps;
export default CustomTooltip;
